/*
 * @Author: edvardchen
 * @Date:   2017-05-23 18:03:41
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-05-23 19:53:34
 */

import { actionTypes } from '../actions/user';

export default (state = {}, action) => {
  const { type, user = {} } = action;
  switch (type) {
    case actionTypes.ACCOUNT_CHANGED:
      return user;
    default:
      return state;
  }
};
